import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteStreet from './autocomplete-street';
import StreetTwo from './street-two';
import City from './city';
import Zip from './zip';
import StateNextOld from './state-next-with-old-select';
import * as sc from './address-next.styles';

const AutocompleteAddressEntry = props => {
  const {
    error,
    value,
    type,
    hideStreet2,
    onChange,
    onBlur,
    touched,
    isLoading,
    setFieldValue,
    isDisabled,
    isStateDisabled,
    setFieldTouched,
    primaryStreetValue,
    primaryStateValue,
    isCosigner,
    setCosignerState,
    showSameStateText,
    setStreetAutocompleteState,
    setCityAutocompleteState,
    setZipAutocompleteState,
    hideErrorMessage
  } = props;

  return (
    <div>
      <sc.Row>
        <AutocompleteStreet
          style={{ fontSize: isCosigner ? '16px' : '14px' }}
          isDisabled={isLoading || isDisabled}
          data-cv-test={`${type}AddressStreetLineOne`}
          error={error[`${type}Street`]}
          name={`${type}Street`}
          id={`${type}Street`}
          touched={touched[`${type}Street`]}
          onBlur={onBlur}
          setFieldValue={setFieldValue}
          streetValue={value[`${type}Street`]}
          type={type}
          setFieldTouched={setFieldTouched}
          primaryStreetValue={primaryStreetValue}
          primaryStateValue={primaryStateValue}
          isCosigner={isCosigner}
          setCosignerState={setCosignerState}
          setStreetAutocompleteState={setStreetAutocompleteState}
          setCityAutocompleteState={setCityAutocompleteState}
          setZipAutocompleteState={setZipAutocompleteState}
          hideErrorMessage={hideErrorMessage}
        />
      </sc.Row>

      {!hideStreet2 && (
        <sc.Row>
          <StreetTwo
            isDisabled={isLoading || isDisabled}
            data-cv-test={`${type}AddressStreetLineTwo`}
            error={error[`${type}Street2`]}
            value={value[`${type}Street2`]}
            name={`${type}Street2`}
            id={`${type}Street2`}
            touched={touched[`${type}Street2`]}
            onChange={onChange}
            onBlur={onBlur}
            isCosigner={isCosigner}
          />
        </sc.Row>
      )}

      <sc.SingleLineWrapper>
        <sc.SingleLineWrapperRowLeft>
          <City
            isDisabled={isLoading || isDisabled}
            data-cv-test={`${type}AddressCity`}
            error={error[`${type}City`]}
            value={value[`${type}City`]}
            name={`${type}City`}
            id={`${type}City`}
            touched={touched[`${type}City`]}
            onChange={onChange}
            onBlur={onBlur}
            fieldValues={value}
            setCityAutocompleteState={setCityAutocompleteState}
            isCosigner={isCosigner}
            hideErrorMessage={hideErrorMessage}
          />
        </sc.SingleLineWrapperRowLeft>

        <sc.StateAndZipWrapper>
          <sc.SingleLineWrapperRowMiddle>
            <StateNextOld
              disabled={isLoading || isDisabled || isStateDisabled}
              onChange={onChange}
              onBlur={onBlur}
              touched={touched[`${type}State`]}
              data-cv-test={`${type}AddressState`}
              error={error[`${type}State`]}
              value={value[`${type}State`] || 'default'}
              name={`${type}State`}
              style={{
                fontSize: isCosigner ? '16px' : '14px',
                color: isStateDisabled && '#AAB1C7'
              }}
              cosigner={isCosigner}
              showSameStateText={showSameStateText}
              hideErrorMessage={hideErrorMessage}
              scrollTag={`${type}State`}
            />
          </sc.SingleLineWrapperRowMiddle>

          <sc.SingleLineWrapperRowRight>
            <Zip
              isDisabled={isLoading || isDisabled}
              data-cv-test={`${type}AddressZip`}
              error={error[`${type}Zip`]}
              value={value[`${type}Zip`]}
              name={`${type}Zip`}
              id={`${type}Zip`}
              touched={touched[`${type}Zip`]}
              onChange={onChange}
              onBlur={onBlur}
              setZipAutocompleteState={setZipAutocompleteState}
              isCosigner={isCosigner}
              hideErrorMessage={hideErrorMessage}
            />
          </sc.SingleLineWrapperRowRight>
        </sc.StateAndZipWrapper>
      </sc.SingleLineWrapper>
    </div>
  );
};

AutocompleteAddressEntry.propTypes = {
  type: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  hideStreet2: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touched: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isStateDisabled: PropTypes.bool,
  setFieldTouched: PropTypes.func.isRequired,
  primaryStreetValue: PropTypes.string,
  primaryStateValue: PropTypes.string,
  isCosigner: PropTypes.bool,
  setCosignerState: PropTypes.func,
  showSameStateText: PropTypes.bool,
  setStreetAutocompleteState: PropTypes.func,
  setCityAutocompleteState: PropTypes.func,
  setZipAutocompleteState: PropTypes.func
};

AutocompleteAddressEntry.defaultProps = {
  type: 'home',
  error: false,
  value: null,
  hideStreet2: false,
  touched: {},
  isLoading: false,
  isDisabled: false,
  isStateDisabled: false,
  primaryStreetValue: '',
  primaryStateValue: '',
  isCosigner: false,
  setCosignerState: () => {},
  showSameStateText: false,
  setStreetAutocompleteState: () => {},
  setCityAutocompleteState: () => {},
  setZipAutocompleteState: () => {}
};

export default AutocompleteAddressEntry;
